export default class Navigation {
  constructor () {
    this.el = {
      trigger: 'js-trigger-menu',
      nav: 'js-navigation-container'
    }

    this.initEvents()
  }

  initEvents () {
    document.getElementById(this.el.trigger).addEventListener('click', (e) => {
      e.preventDefault()


      let navigation = this.navigation
      if (navigation.classList.contains('active')) {
        navigation.classList.remove('active')
      } else {
        navigation.classList.add('active')
      }

    })
  }

  /**
   * @inheritDoc Get navigation element
   * @return {HTMLElement}
   */
  get navigation () {
    return document.getElementById(this.el.nav)
  }
}